import type { MultiSelectOption } from '@/shared/ui';
import { regionalVideoCountrySchema } from '@travel-planner/shared/schemas';

// Country options for the mapper's country filter. Values are full country
// NAMES (e.g. "Portugal"), matching what `products.country` /
// `hyperguestHotel.country` store and what the backend `countries` filter
// compares against — a faithful port of the legacy HotelMapperPage dropdown,
// which used the same hardcoded country-name list. Priority countries float to
// the top; the rest are alphabetical.
const PRIORITY_COUNTRIES = ['Portugal', 'Spain', 'Brazil', 'Italy'] as const;

const priority = new Set<string>(PRIORITY_COUNTRIES);

const remaining = regionalVideoCountrySchema.options
  .filter((name) => !priority.has(name))
  .slice()
  .sort((a, b) => a.localeCompare(b));

export const MAPPER_COUNTRY_OPTIONS: MultiSelectOption[] = [
  ...PRIORITY_COUNTRIES,
  ...remaining,
].map((name) => ({ value: name, label: name }));
